export default __webpack_public_path__ + "a3858455b663bf0221ca185a4eaff9ab.svg";